import * as React from "react";
import { Box, Button, TextField, FormControl, InputLabel, Select, MenuItem } from "../../../components/mui";
import Modal from "../../../components/shared/Modal";
import { useToast } from "../../../components/shared/ToastProvider";

import "../../../styles/main.css";
import "../../../styles/pages/condoUnitDetail.css";

// UI-only form for creating/updating a maintenance record.
export default function MaintenanceFormModal({
  open,
  onClose,
  mode = "add", // "add" | "edit"
  initialValues = {}
}) {
  const isEdit = mode === "edit";
  const { showToast } = useToast();

  const handlePrimaryClick = () => {
    showToast({
      message: isEdit ? "Maintenance updated" : "Maintenance created",
      severity: "success"
    });
    if (onClose) onClose();
  };

  const actions = (
    <>
      <Button variant="outlined" onClick={onClose}>
        Cancel
      </Button>
      <Button variant="contained" onClick={handlePrimaryClick}>
        {isEdit ? "Update" : "Create"}
      </Button>
    </>
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={isEdit ? "Edit Maintenance Record" : "Add Maintenance Record"}
      actions={actions}
      maxWidth="sm"
      fullWidth
    >
      <Box className="modal-form-grid" style={{ marginTop: 8 }}>
        {/* Payment Date */}
        <TextField
          fullWidth
          required
          size="small"
          type="date"
          className="modal-form-row"
          label="Payment Date"
          InputLabelProps={{ shrink: true }}
          defaultValue={initialValues.paymentDateRaw || ""}
        />

        {/* Description */}
        <TextField
          fullWidth
          required
          multiline
          rows={3}
          size="small"
          className="modal-form-row"
          label="Description"
          defaultValue={initialValues.description || ""}
        />

        {/* In-Charge */}
        <TextField
          fullWidth
          required
          size="small"
          className="modal-form-row"
          label="In-Charge"
          defaultValue={initialValues.inCharge || ""}
        />

        {/* Currency (select) */}
        <Box className="modal-form-row">
          <FormControl fullWidth required size="small">
            <InputLabel>Currency</InputLabel>
            <Select
              defaultValue={initialValues.currency || "PHP"}
              label="Currency"
            >
              <MenuItem value="PHP">PHP</MenuItem>
            </Select>
          </FormControl>
        </Box>

        {/* Amount (separate line) */}
        <TextField
          fullWidth
          required
          size="small"
          type="number"
          className="modal-form-row"
          label="Amount"
          placeholder="0.00"
          defaultValue={initialValues.amountValue || "0.00"}
          inputProps={{ step: "0.01" }}
        />

        {/* Acct Entry Date */}
        <TextField
          fullWidth
          required
          size="small"
          type="date"
          className="modal-form-row"
          label="Acct Entry Date"
          InputLabelProps={{ shrink: true }}
          defaultValue={initialValues.acctEntryDateRaw || ""}
        />
      </Box>
    </Modal>
  );
}
